/* global window */

import { trackLinkClick } from '../../scripts/tag-manager';

import './PressItem.scss';
import template from './PressItem.vhtml';

export default {
	name: 'PressItem',
	template: template,
	props: {
		'item': {
			type: Object,
			default: null,
		},
	},
	data: () => ({
		chosenFile: '',
	}),
	methods: {
		setupBgi: img => `url(${img})`,
		downloadFile() {
			if (this.downloadFile !== '') {
				this.trackClick(this.downloadFile);
				window.location.href = this.chosenFile;
			}
		},
		generateYoutubeUrl(id) {
			return `https://www.youtube.com/watch?v=${id}`;
		},
		trackClick(label) {
			trackLinkClick(label);
		},
	},
};
